import { gql } from '@apollo/client';

export const GENERATE_BULK_PARTNER_FILES_MUTATION = gql`
  mutation generateBulkPartnerFiles($input: GenerateBulkPartnerFilesInput!) {
    generateBulkPartnerFiles(input: $input) {
      correlationId
    }
  }
`;
